<style>
.padding_10 {
  padding: 0px !important;
}
</style>
<template>
  <div>
    <div v-if="submit_loader" style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      ">
      <div class="text-xs-center" large></div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form id="create_festival" data-vv-scope="CreateFestival" @submit.prevent="validateBeforeSubmit('CreateFestival')">
              <input type="hidden" name="festival_id" v-model="festival_object.id" />
              <v-card-text>
                <v-layout row wrap>
                  <!-- <v-flex xs12 md12 lg12> -->
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Name <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="name" v-model="festival_object.name" label="Name"
                      v-validate="'required'" :error-messages="errors.collect('CreateFestival.name')" clearable
                      solo flat data-vv-as="Name"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Address Short <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="address_short" v-model="festival_object.address_short" label="Address Short"
                      v-validate="'required'" :error-messages="errors.collect('CreateFestival.address_short')" clearable
                      solo flat data-vv-as="Address Short"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Address Long <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="address_long" v-model="festival_object.address_long" label="Address Long"
                      v-validate="'required'" :error-messages="errors.collect('CreateFestival.address_long')" clearable
                      solo flat data-vv-as="Address Long"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Festival Name <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-select
                      name="festival_name"
                      v-model="festival_object.festival_name"
                      :items="festivalNameOptions"
                      label="Festival Name"
                      v-validate="'required'"
                      :error-messages="errors.collect('CreateFestival.festival_name')"
                      clearable
                      solo
                      flat
                      data-vv-as="Festival Name"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Thumbnail Image <span style="color: red;">*</span></label>
                    </v-flex>
                    <input
                      type="file"
                      name="thumbnail_image"
                      accept="image/*"
                      v-validate="thumbnailImageValidationRule"
                      data-vv-as="Thumbnail Image"
                      @change="onThumbnailImageChange"
                    />
                    <div v-if="errors.collect('CreateFestival.thumbnail_image').length" style="color:#ff5252;font-size:12px;">
                      {{ errors.collect('CreateFestival.thumbnail_image')[0] }}
                    </div>
                    <div v-if="festival_object.thumbnail_image_url" style="margin-top: 8px;">
                      <a :href="festival_object.thumbnail_image_url" target="_blank" rel="noopener">
                        <img
                          :src="festival_object.thumbnail_image_url"
                          alt="thumbnail"
                          style="width: 64px; height: 64px; object-fit: cover; border-radius: 6px;"
                        />
                      </a>
                    </div>
                  </v-flex>
                  
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Additional Images <span style="color: red;">*</span></label>
                    </v-flex>
                    <input
                      type="file"
                      name="additional_images"
                      accept="image/*"
                      multiple
                      v-validate="additionalImagesValidationRule"
                      data-vv-as="Additional Images"
                      @change="onAdditionalImagesChange"
                    />
                    <div v-if="errors.collect('CreateFestival.additional_images').length" style="color:#ff5252;font-size:12px;">
                      {{ errors.collect('CreateFestival.additional_images')[0] }}
                    </div>
                    <div
                      v-if="Array.isArray(festival_object.existing_additional_images) && festival_object.existing_additional_images.length"
                      style="display:flex; gap:8px; flex-wrap:wrap; margin-top:8px;"
                    >
                      <a
                        v-for="(img, idx) in festival_object.existing_additional_images"
                        :key="`existing-img-${idx}`"
                        :href="img"
                        target="_blank"
                        rel="noopener"
                      >
                        <img
                          :src="img"
                          alt="additional"
                          style="width: 48px; height: 48px; object-fit: cover; border-radius: 6px;"
                        />
                      </a>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Latitude <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="latitude" v-model="festival_object.latitude"
                      label="Latitude" v-validate="'required|decimal:8|min_value:-90|max_value:90'"
                      :error-messages="errors.collect('CreateFestival.latitude')" clearable solo flat
                      data-vv-as="Latitude"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Longitude <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="longitude" v-model="festival_object.longitude"
                      label="Longitude" v-validate="'required|decimal:8|min_value:-180|max_value:180'"
                      :error-messages="errors.collect('CreateFestival.longitude')" clearable solo flat
                      data-vv-as="Longitude"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Near By Local Stations <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="nearby_local_stations" v-model="festival_object.nearby_local_stations" label="Near By Local Stations"
                      v-validate="'required'" :error-messages="errors.collect('CreateFestival.nearby_local_stations')" clearable
                      solo flat data-vv-as="Near By Local Stations"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Near By Metro Stations</label>
                    </v-flex>
                    <v-text-field name="nearby_metro_stations" v-model="festival_object.nearby_metro_stations" label="Near By Metro Stations"
                      :error-messages="errors.collect('CreateFestival.nearby_metro_stations')" clearable
                      solo flat data-vv-as="Near By Metro Stations"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Description <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="remark" v-model="festival_object.remark" label="Description"
                      :error-messages="errors.collect('CreateFestival.remark')" clearable
                      solo flat data-vv-as="Description"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Booking Link</label>
                    </v-flex>
                    <v-text-field name="booking_link" v-model="festival_object.booking_link" label="Booking Link"
                      :error-messages="errors.collect('CreateFestival.booking_link')" clearable
                      solo flat data-vv-as="Booking Link"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>History and Origins <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="history_and_origins" v-model="festival_object.history_and_origins"
                      label="History and Origins" v-validate="'required'"
                      :error-messages="errors.collect('CreateFestival.history_and_origins')" clearable solo flat
                      data-vv-as="History and Origins"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Queue Types and Wait Times <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="queue_types_and_wait_times" v-model="festival_object.queue_types_and_wait_times"
                      label="Queue Types and Wait Times" v-validate="'required'"
                      :error-messages="errors.collect('CreateFestival.queue_types_and_wait_times')" clearable solo flat
                      data-vv-as="Queue Types and Wait Times"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Festival and Tradition <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="festival_and_tradition" v-model="festival_object.festival_and_tradition"
                      label="Festival and Tradition" v-validate="'required'"
                      :error-messages="errors.collect('CreateFestival.festival_and_tradition')" clearable solo flat
                      data-vv-as="Festival and Tradition"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Aarti Time <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="aarti_time" v-model="festival_object.aarti_time"
                      label="Aarti Time"
                      :error-messages="errors.collect('CreateFestival.aarti_time')" clearable solo flat
                      data-vv-as="Aarti Time"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Instagram Link </label>
                    </v-flex>
                    <v-text-field name="instagram_link" v-model="festival_object.instagram_link" label="Instagram Link"
                      :error-messages="errors.collect('CreateFestival.instagram_link')" clearable
                      solo flat data-vv-as="Instagram Link"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Digital Link</label>
                    </v-flex>
                    <v-text-field name="digital_link" v-model="festival_object.digital_link" label="Digital Link"
                      :error-messages="errors.collect('CreateFestival.digital_link')" clearable
                      solo flat data-vv-as="Digital Link"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Visarjan Place <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="visarjan_place" v-model="festival_object.visarjan_place" label="Visarjan Place"
                      :error-messages="errors.collect('CreateFestival.visarjan_place')" clearable
                      solo flat data-vv-as="Visarjan Place"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Visarjan Date <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuStart" v-model="festival_object.menu_start_date" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="festival_object.visarjan_date"
                            name="visarjan_date"
                            v-validate="'required'"
                            data-vv-scope="CreateFestival"
                            :error-messages="errors.collect('CreateFestival.visarjan_date')"
                            label="Select Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            flat
                            data-vv-as="Visarjan Date"
                          ></v-text-field>
                        </template>

                        <v-date-picker v-model="festival_object.visarjan_date" no-title scrollable :min="current_date">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="festival_object.visarjan_date = null">Clear</v-btn>
                          <v-btn text color="primary" @click="festival_object.menu_start_date = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuStart.save(festival_object.visarjan_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Visarjan Time</label>
                    </v-flex>
                    <v-text-field name="visarjan_time" v-model="festival_object.visarjan_time"
                      label="Visarjan Time"
                      :error-messages="errors.collect('CreateFestival.visarjan_time')" clearable solo flat
                      data-vv-as="Visarjan Time"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Expected Time <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="expected_time" v-model="festival_object.expected_time"
                      label="Expected Time" v-validate="'required'"
                      :error-messages="errors.collect('CreateFestival.expected_time')" clearable solo flat
                      data-vv-as="Expected Time"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small :disabled="submit_loader" type="submit" style="margin-top: 25px;">
                      {{ isEditMode ? 'Update' : 'Create' }}
                    </v-btn>
                    <v-btn flat small to="/yatri-festival" @click="cancelForm" style="margin-top: 25px;">Cancel</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar :color="snackBar.color" :top="snackBar.top" :bottom="snackBar.bottom" :left="snackBar.left"
        :right="snackBar.right" v-model="snackBar.show">
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import axios from 'axios';

  export default {
    name: "CreateFestival",

    props: {
      prefillData: {
        type: Object,
        default: null,
      },
    },

    data() {
      const today = new Date().toISOString().substr(0, 10);

      return {
        valid: false,
        submit_loader: false,

        current_date: today,
        festivalNameOptions: ['Ganesh Chaturthi', 'Diwali'],

        festival_object: {
          id: null,
          name: null,
          festival_name: null,
          thumbnail_image_url: null,
          thumbnail_image_file: null,
          additional_images: null,
          additional_image_files: [],
          existing_additional_images: [],
          latitude: null,
          longitude: null,
          address_short: null,
          address_long: null,
          nearby_local_stations: null,
          nearby_metro_stations: null,
          remark: null,
          booking_link: null,
          history_and_origins: null,
          queue_types_and_wait_times: null,
          festival_and_tradition: null,
          aarti_time: null,
          instagram_link: null,
          digital_link: null,
          menu_start_date: false,
          visarjan_place: null,
          visarjan_date: null,
          visarjan_date_time: null,
          visarjan_time: null,
          expected_time: null,
        },

        snackBar: {
          show: false,
          message: "",
          color: "",
          top: true,
          right: true,
        },
      };
    },

    computed: {
      isEditMode() {
        return !!this.festival_object.id;
      },
      thumbnailImageValidationRule() {
        const hasExistingThumbnail = !!this.festival_object.thumbnail_image_url;
        return this.isEditMode && hasExistingThumbnail ? '' : 'required';
      },
      additionalImagesValidationRule() {
        const hasExistingAdditionalImages =
          Array.isArray(this.festival_object.existing_additional_images) &&
          this.festival_object.existing_additional_images.length > 0;
        return this.isEditMode && hasExistingAdditionalImages ? '' : 'required';
      },
    },

    watch: {
      prefillData: {
        handler(newVal) {
          if (newVal) {
            this.festival_object.id = newVal.festival_id || newVal.edit_festival_id || newVal.festivalId || newVal.festival_uuid || newVal.id || newVal._id || newVal.uuid || null;
            this.festival_object.name = newVal.name || null;
            this.festival_object.festival_name = newVal.festival_name || newVal.title || null;
            const normalizedAdditionalImages = this.normalizeImageList(newVal.additional_images);
            this.festival_object.additional_images = normalizedAdditionalImages.length
              ? normalizedAdditionalImages.join(',')
              : null;
            this.festival_object.additional_image_files = [];
            this.festival_object.existing_additional_images = normalizedAdditionalImages;
            this.festival_object.thumbnail_image_url = newVal.thumbnail_image || null;
            this.festival_object.latitude = newVal.latitude || null;
            this.festival_object.longitude = newVal.longitude || null;
            this.festival_object.nearby_local_stations = this.formatNearbyStationsForInput(newVal.nearby_local_stations);
            this.festival_object.nearby_metro_stations = this.formatNearbyStationsForInput(newVal.nearby_metro_stations);

            const parsedInfo = this.parseAdditionalInfo(newVal.additional_info);
            if (!this.festival_object.nearby_local_stations) {
              this.festival_object.nearby_local_stations = this.formatNearbyStationsForInput(parsedInfo.nearby_local_stations);
            }
            if (!this.festival_object.nearby_metro_stations) {
              this.festival_object.nearby_metro_stations = this.formatNearbyStationsForInput(parsedInfo.nearby_metro_stations);
            }
            this.festival_object.address_short = newVal.address_short || null;
            this.festival_object.address_long = newVal.address_long || parsedInfo.address_long || null;
            this.festival_object.remark = parsedInfo.remark || null;
            this.festival_object.booking_link = parsedInfo.booking_link || null;
            this.festival_object.history_and_origins = parsedInfo.history_and_origins || null;
            this.festival_object.queue_types_and_wait_times = parsedInfo.queue_types_and_wait_times || null;
            this.festival_object.festival_and_tradition = parsedInfo.festival_and_tradition || null;
            this.festival_object.aarti_time = parsedInfo.aarti_time || null;
            this.festival_object.instagram_link = parsedInfo.instagram_link || null;
            this.festival_object.digital_link = parsedInfo.digital_link || null;
            this.festival_object.visarjan_place = parsedInfo.visarjan_place || null;
            this.festival_object.visarjan_date_time = parsedInfo.visarjan_date_time || null;
            this.festival_object.visarjan_date = this.extractDateOnly(parsedInfo.visarjan_date_time);
            this.festival_object.visarjan_time = parsedInfo.visarjan_time || null;
            this.festival_object.expected_time = parsedInfo.expected_time || null;

            // Scroll to form
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.resetFestivalObject();
          }
        },
        immediate: true,
      },
    },

    methods: {
      reloadPage() {
        window.location.reload();
      },
      cancelForm() {
        this.resetFestivalObject();
        this.$emit("clear-prefill");
      },
      resetFestivalObject() {
        this.festival_object = {
          id: null,
          name: null,
          festival_name: null,
          address_short: null,
          address_long: null,
          thumbnail_image_url: null,
          thumbnail_image_file: null,
          additional_images: null,
          additional_image_files: [],
          existing_additional_images: [],
          latitude: null,
          longitude: null,
          nearby_local_stations: null,
          nearby_metro_stations: null,
          remark: null,
          booking_link: null,
          history_and_origins: null,
          queue_types_and_wait_times: null,
          festival_and_tradition: null,
          aarti_time: null,
          instagram_link: null,
          digital_link: null,
          menu_start_date: false,
          visarjan_place: null,
          visarjan_date: null,
          visarjan_date_time: null,
          visarjan_time: null,
          expected_time: null,
        };
      },
      normalizeImageList(images) {
        if (!images) return [];

        if (Array.isArray(images)) {
          return images.filter(Boolean);
        }

        if (typeof images === 'string') {
          try {
            const parsed = JSON.parse(images);
            if (Array.isArray(parsed)) {
              return parsed.filter(Boolean);
            }
          } catch (e) {
            return images
              .split(',')
              .map((img) => img.trim())
              .filter(Boolean);
          }
        }

        return [];
      },
      extractDateOnly(value) {
        if (!value) return null;
        const raw = String(value).trim();
        if (!raw) return null;

        const datePart = raw.split('T')[0].split(' ')[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
          return datePart;
        }

        return null;
      },
      parseAdditionalInfo(additionalInfo) {
        if (!additionalInfo) return {};

        if (typeof additionalInfo === "object") {
          return additionalInfo;
        }

        try {
          return JSON.parse(additionalInfo);
        } catch (e) {
          return {};
        }
      },
      formatNearbyStationsForInput(nearbyStations) {
        if (!nearbyStations) return null;

        if (Array.isArray(nearbyStations)) {
          return nearbyStations
            .map((station) => {
              if (typeof station === 'string') return station;
              if (station && typeof station === 'object') return station.name || station.station_name || station.id || null;
              return null;
            })
            .filter(Boolean)
            .join(', ');
        }

        if (typeof nearbyStations === 'object') {
          try {
            if (nearbyStations.name || nearbyStations.station_name) {
              return nearbyStations.name || nearbyStations.station_name;
            }

            const values = Object.values(nearbyStations)
              .map((value) => {
                if (typeof value === 'string') return value;
                if (Array.isArray(value)) {
                  return value
                    .map((v) => {
                      if (typeof v === 'string') return v;
                      if (v && typeof v === 'object') return v.name || v.station_name || null;
                      return null;
                    })
                    .filter(Boolean)
                    .join(', ');
                }
                if (value && typeof value === 'object') return value.name || value.station_name || null;
                return null;
              })
              .filter(Boolean);

            return values.length ? values.join(', ') : JSON.stringify(nearbyStations);
          } catch (e) {
            return null;
          }
        }

        if (typeof nearbyStations === 'string') {
          try {
            const parsed = JSON.parse(nearbyStations);
            if (Array.isArray(parsed)) {
              return parsed.join(', ');
            }
            if (parsed && typeof parsed === 'object') {
              const values = Object.values(parsed).filter(Boolean);
              return values.length ? values.join(', ') : nearbyStations;
            }
            return nearbyStations;
          } catch (e) {
            return nearbyStations;
          }
        }

        return String(nearbyStations);
      },
      getNearbyLocalStationsPayload() {
        const raw = String(this.festival_object.nearby_local_stations || '').trim();
        if (!raw) return [];

        const stations = raw
          .split(',')
          .map((station) => station.trim())
          .filter(Boolean);

        return stations;
      },
      getNearbyMetroStationsPayload() {
        const raw = String(this.festival_object.nearby_metro_stations || '').trim();
        if (!raw) return [];

        const stations = raw
          .split(',')
          .map((station) => station.trim())
          .filter(Boolean);

        return stations;
      },
      trimText(value) {
        if (value === null || value === undefined) return null;
        const trimmed = String(value).trim();
        return trimmed === '' ? null : trimmed;
      },
      getAdditionalInfoPayload() {
        const additionalInfo = {
          address_long: this.trimText(this.festival_object.address_long),
          remark: this.trimText(this.festival_object.remark),
          booking_link: this.trimText(this.festival_object.booking_link),
          history_and_origins: this.trimText(this.festival_object.history_and_origins),
          queue_types_and_wait_times: this.trimText(this.festival_object.queue_types_and_wait_times),
          festival_and_tradition: this.trimText(this.festival_object.festival_and_tradition),
          aarti_time: this.trimText(this.festival_object.aarti_time),
          instagram_link: this.trimText(this.festival_object.instagram_link),
          digital_link: this.trimText(this.festival_object.digital_link),
          visarjan_place: this.trimText(this.festival_object.visarjan_place),
          visarjan_date_time: this.trimText(this.festival_object.visarjan_date || this.festival_object.visarjan_date_time),
          visarjan_time: this.trimText(this.festival_object.visarjan_time),
          expected_time: this.trimText(this.festival_object.expected_time),
        };

        const hasAnyValue = Object.values(additionalInfo).some(
          (v) => v !== null && v !== undefined && String(v).trim() !== ""
        );

        return hasAnyValue ? JSON.stringify(additionalInfo) : null;
      },
     
      onThumbnailImageChange(event) {
        const file = event && event.target && event.target.files && event.target.files[0]
          ? event.target.files[0]
          : null;
        this.festival_object.thumbnail_image_file = file;
      },
      onAdditionalImagesChange(event) {
        const files = event && event.target && event.target.files
          ? Array.from(event.target.files)
          : [];
        this.festival_object.additional_image_files = files;
        if (files.length) {
          // Keep DB images unchanged unless backend processes uploaded files.
          // Do not overwrite with local file names.
          this.festival_object.additional_images = null;
        }
      },
      isValidHttpUrl(value) {
        if (!value) return false;

        try {
          const parsed = new URL(String(value));
          return parsed.protocol === "http:" || parsed.protocol === "https:";
        } catch (e) {
          return false;
        }
      },
      validateFestivalFields() {
        const latitude = Number(this.festival_object.latitude);
        const longitude = Number(this.festival_object.longitude);

        if (Number.isNaN(latitude) || latitude < -90 || latitude > 90) {
          this.snackBar.message = "Latitude must be between -90 and 90.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          return false;
        }

        if (Number.isNaN(longitude) || longitude < -180 || longitude > 180) {
          this.snackBar.message = "Longitude must be between -180 and 180.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          return false;
        }

        // const requiredUrls = [
        //   { key: "instagram_link", label: "Instagram Link" },
        // ];

        // for (const field of requiredUrls) {
        //   if (!this.isValidHttpUrl(this.festival_object[field.key])) {
        //     this.snackBar.message = `${field.label} must be a valid URL (http/https).`;
        //     this.snackBar.color = "error";
        //     this.snackBar.show = true;
        //     return false;
        //   }
        // }

        if (!this.isEditMode && !(this.festival_object.thumbnail_image_file instanceof File)) {
          this.snackBar.message = "Thumbnail Image is required.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          return false;
        }

        const hasAdditionalImageFiles =
          this.festival_object.additional_image_files && this.festival_object.additional_image_files.length > 0;
        const hasAdditionalImageText = !!this.festival_object.additional_images;
        const hasExistingAdditionalImages =
          Array.isArray(this.festival_object.existing_additional_images) &&
          this.festival_object.existing_additional_images.length > 0;

        if (!hasAdditionalImageFiles && !hasAdditionalImageText && !hasExistingAdditionalImages) {
          this.snackBar.message = "At least one Additional Image is required.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          return false;
        }

        if (hasAdditionalImageFiles) {
          const maxSize = 5 * 1024 * 1024;
          for (const file of this.festival_object.additional_image_files) {
            if (!(file && file.type && file.type.startsWith("image/"))) {
              this.snackBar.message = "Only image files are allowed in Additional Images.";
              this.snackBar.color = "error";
              this.snackBar.show = true;
              return false;
            }
            if (file.size > maxSize) {
              this.snackBar.message = "Each Additional Image must be up to 5MB.";
              this.snackBar.color = "error";
              this.snackBar.show = true;
              return false;
            }
          }
        }

        return true;
      },
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            if (!this.validateFestivalFields()) {
              return;
            }
            this[scope]();
          } else {
            this.snackBar.message = "Please fill all required fields correctly.";
            this.snackBar.show = true;
          }
        });
      },
      allowFloat(e, field) {
        const char = String.fromCharCode(e.keyCode || e.which);
        const value = this.festival_object[field] || "";

        if (/^[0-9]$/.test(char)) return;

        if (char === '.' && !value.includes('.')) return;

        e.preventDefault();
      },
      allowInteger(e) {
        const char = String.fromCharCode(e.keyCode || e.which);

        if (/^[0-9]$/.test(char)) return;

        e.preventDefault();
      },

      preventDoubleDot(field) {
        let v = this.festival_object[field] || "";
        const firstDot = v.indexOf(".");
        const lastDot = v.lastIndexOf(".");

        if (firstDot !== lastDot) {
          this.festival_object[field] = v.replace(/\.(?=.*\.)/, "");
        }
      },
      CreateFestival() {
        this.submit_loader = true;

        const festivalId = this.festival_object.id ? String(this.festival_object.id).trim() : "";
        const isEdit = !!festivalId;

        if (this.isEditMode && !festivalId) {
          this.snackBar.message = "Festival ID is missing for update.";
          this.snackBar.color = "error";
          this.snackBar.show = true;
          this.submit_loader = false;
          return;
        }

        const formData = new FormData();

        if (isEdit) {
          formData.append('id', festivalId);
        }

        formData.append('name', this.festival_object.name || '');
        formData.append('festival_name', this.festival_object.festival_name || '');
        formData.append('address_short', this.festival_object.address_short || '');
        formData.append('latitude', this.festival_object.latitude || '');
        formData.append('longitude', this.festival_object.longitude || '');

        const nearbyLocalStationsPayload = this.getNearbyLocalStationsPayload();
        nearbyLocalStationsPayload.forEach((station) => {
          formData.append('nearby_local_stations[]', station);
        });

        const nearbyMetroStationsPayload = this.getNearbyMetroStationsPayload();
        nearbyMetroStationsPayload.forEach((station) => {
          formData.append('nearby_metro_stations[]', station);
        });

        if (this.festival_object.thumbnail_image_file instanceof File) {
          formData.append('thumbnail_image', this.festival_object.thumbnail_image_file);
        }

        const hasNewAdditionalImageFiles =
          this.festival_object.additional_image_files &&
          this.festival_object.additional_image_files.length;

        if (hasNewAdditionalImageFiles) {
          this.festival_object.additional_image_files.forEach((file) => {
            formData.append('additional_image_files[]', file);
          });
        }

        if (this.festival_object.additional_images && !hasNewAdditionalImageFiles) {
          formData.append('additional_images', this.festival_object.additional_images);
        }

        const additionalInfoPayload = this.getAdditionalInfoPayload();
        if (additionalInfoPayload) {
          formData.append('additional_info', additionalInfoPayload);
        }

        axios.post(
          `${process.env.VUE_APP_API_URL}/api/v4/${isEdit ? 'edit-festival-data' : 'add-festival-data'}`,
          formData,
          {
            headers: {
              ...this.$headers,
              'Content-Type': 'multipart/form-data',
            },
          }
        )
          .then((response) => {
            if (response.data.status == true) {

              this.snackBar.message = response.data.message;
              this.snackBar.show = true;

              this.$emit("created");
              this.$emit("clear-prefill");
              this.resetFestivalObject();

            } else {
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            }

          })
          .finally(() => {
            this.submit_loader = false;
          });
      }
    },
    mounted() {
      this.current_date = moment().format("YYYY-MM-DD");
    }
  };

</script>
